module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("数据统计")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.freashRent
    }
  }, [_vm._v("手动更细订单总金额与租金")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-danger"
  }, [_c('h3', [_vm._v("昨日新用户数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.lastUserNum))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-info"
  }, [_c('h3', [_vm._v("昨日成功订单数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.lastSuccessOrder))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-warning"
  }, [_c('h3', [_vm._v("过去一个月注册用户数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.monthRegister))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-success"
  }, [_c('h3', [_vm._v("过去一个月支付订单数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.monthSuccessOrder))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("累计获的租金")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.rentalSum))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("上架商品总数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.onlineProduct))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("过去一个月获的租金")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.monthRental))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h3', [_vm._v("已芝麻绑定用户数")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.fetch.zmUserNum))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-info"
  }, [_vm._v("\n                    待发货订单\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderUnderDeliver))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-silver"
  }, [_vm._v("\n                    待返还确认订单\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderUnderReturn))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-warning"
  }, [_vm._v("\n                    未付款订单数\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderUnderPay))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-success"
  }, [_vm._v("\n                    待返还订单\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderDelivered))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "demo-color-box bg-danger"
  }, [_vm._v("\n                    订单总金额\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.fetch.orderPayMount))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("租赁次数前10的商品")])]), _vm._v(" "), _vm._l((_vm.fetch.rentalCountTopProducts), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_vm._v("\n                        " + _vm._s(++i) + "、" + _vm._s(o.name) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("累计租金最高的前10商品")])]), _vm._v(" "), _vm._l((_vm.fetch.rentalSumTopProducts), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_vm._v("\n                        " + _vm._s(++i) + "、" + _vm._s(o.name) + "\n                    ")])
  })], 2)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1204ccb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/GetStatistics.vue
// module id = 712
// module chunks = 1